import modules_list from './list/index.js'
import modules_form from './form/index.js'
import modules_balance from './balance/index.js'
import _actions_setting_open from './_actions/setting/open.js'
import _actions_search from './_actions/search.js'
import _actions_remove from './_actions/remove.js'
import _actions_default_search from './_actions/default_search.js'
import _actions_create from './_actions/create.js'
import _actions_clean from './_actions/clean.js'
import _getters_setting_opened from './_getters/setting/opened.js'
import _getters_loading from './_getters/loading.js'
import _getters_legend from './_getters/legend.js'
import _getters_formData from './_getters/formData.js'
import _getters_filter_tabActive from './_getters/filter_tabActive.js'
import _mutations_set_list from './_mutations/set_list.js'
import _mutations_set_form from './_mutations/set_form.js'
import state from './state.js'

export default {
    namespaced: true,
    state,
    mutations:{
        set_form: _mutations_set_form,
        set_list: _mutations_set_list,
    },
    getters:{
        filter_tabActive: _getters_filter_tabActive,
        formData: _getters_formData,
        legend: _getters_legend,
        loading: _getters_loading,
        setting_opened: _getters_setting_opened,
    },
    actions:{
        clean: _actions_clean,
        create: _actions_create,
        default_search: _actions_default_search,
        remove: _actions_remove,
        search: _actions_search,
        setting_open: _actions_setting_open,
    },
    modules:{
        balance: modules_balance,
        form: modules_form,
        list: modules_list,
    },
}